import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Overlay,
  Spinner,
  Table,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import viewAction from "../../assets/images/viewaction.svg";
import filtericon from "../../assets/images/filter.svg";
import greenTick from "../../assets/images/greenTick.svg";
import WorkFlowMachineLogDetailModal from "./WorkFlowMachineLogDetailModal";
import { commonservices } from "../../services/CommonServices";
import searchicon from "../../assets/images/searchicon.svg";
import WorkFlowLogFilterPopup from "./WorkFlowLogFilterPopup";
import { useDispatch } from "react-redux";
import { WorkflowScheduleLogGetList } from "../../services/ReduxTookit/Slice/AllLogRedux";
import useDebounce from "../../hooks/useDebounce";
import Nodata from "./Nodata";

function WorkFlowLogModal(props) {
  const toUtcDayStartIso = (date) => {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return "";

    return new Date(
      Date.UTC(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        0,
        0,
        0,
        0
      )
    ).toISOString();
  };

  const toUtcDayEndIso = (date) => {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return "";

    return new Date(
      Date.UTC(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        23,
        59,
        59,
        999
      )
    ).toISOString();
  };

  let dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  let [WorkFLowLogList, setWorkFLowLogList] = useState([]);
  const [modalDetailShow, setDetailModalShow] = useState(false);
  const [workflowlogid, setworkflowlogid] = useState(0);

  const [showSearch, setShowSearch] = useState(false);
  const [SearchTerm, setSearchTerm] = useState("");

  const [status, setStatus] = useState("");
  const today = new Date();

  const sevenDaysAgo = new Date();

  const [showSchedularPopup, setShowSchedularPopup] = useState(false);
  sevenDaysAgo.setDate(today.getDate() - 6);

  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState("");

  const targetFilter = useRef(null);
  const [FilterData, setFilterData] = useState(null);

  const [mainCount, setMainCount] = useState(0);
  const [subCount, setSubCount] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  useLayoutEffect(() => {
    setStartDate(sevenDaysAgo);
    setEndDate(new Date(today.setDate(today.getDate())));
  }, []);
  useEffect(() => {
    const resetValues = {
      startdate: startDate,
      enddate: endDate,
      SearchTerm: "",
      status: "",
    };

    setFilterData(resetValues);
  }, [startDate, endDate]);

  const debouncingValue = useDebounce(SearchTerm, 500);

  async function fnLogList(searchData) {
    if (startDate && !endDate) return;
    setLoading(true);

    let body = {
      workflowid: parseInt(props.id),
      startdate: FilterData?.startdate ? toUtcDayStartIso(FilterData?.startdate) : "",
      enddate: FilterData?.enddate ? toUtcDayEndIso(FilterData?.enddate) : "",
      status: FilterData?.status ? FilterData?.status : "",
      searchtext: debouncingValue || "",
    };

    dispatch(WorkflowScheduleLogGetList(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let sorted_array = [...res?.payload?.data?.data?.dataList1]?.sort(
          (a, b) => a.starton - b.starton
        );

        setWorkFLowLogList(sorted_array);
        setMainCount(res?.payload?.data?.recordcount);
        setSubCount(
          res?.payload?.data?.data?.dataList1[0]?.filteredrecordcount
        );
        setLoading(false);
      } else {
        setWorkFLowLogList([]);
        setMainCount(0);
        setSubCount(0);
        setLoading(false);
      }
    });
  }

  useEffect(() => {
    if (startDate && endDate) {
      fnLogList();
    }
  }, [props.id, FilterData, debouncingValue]);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleshowSearch = () => {
    setShowSearch(!showSearch);
  };
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  function fnWorkflowMachineLoggetlist(id) {
    setworkflowlogid(id);
    setDetailModalShow(true);
  }
  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };
  const handleshowSchedularPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSchedularPopup(!showSchedularPopup);
  };
  const handleSchedularSubmit = (data) => {
    setFilterData(data);
  };

  const FnForSetStatus = (data) => {
    setStatus(data);
  };
  return (
    <>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
        className="normal-modal log-modal model-dimension machine-log-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Log
            {/* {showMessage && ( */}
            <>
              {" | "}
              <span className="Work-log-filter">
                Search result <b> {subCount} </b> out of <b>{mainCount} </b>{" "}
                logs, searched/filtered by
              </span>
              <span className="Work-log-filter-green">
                <b>
                  {" "}
                  {` "${SearchTerm
                      ? "Search = " + SearchTerm
                      : FilterData?.SearchTerm
                        ? "Search = " + FilterData?.SearchTerm
                        : FilterData?.status
                          ? "Status = " + FilterData?.status
                          : "Dates = " +
                          commonservices.getDateInFormatCustom(
                            FilterData?.startdate,
                            null,
                            "MM/DD/yyyy"
                          ) +
                          " to " +
                          commonservices.getDateInFormatCustom(
                            FilterData?.enddate,
                            null,
                            "MM/DD/yyyy"
                          )
                    }"`}
                </b>
              </span>
            </>
            {/* )} */}
          </Modal.Title>

          <div className="log-main-page">
            {showSearch ? (
              <div className="header-search-input searchplaceholder">
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">
                    <img
                      src={searchicon}
                      alt="searchicon"
                      onClick={handleshowSearch}
                      className="cursor-pointer"
                    />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search Workflow Log Note"
                    aria-label="Search"
                    value={SearchTerm}
                    aria-describedby="basic-addon1"
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setShowMessage(true);
                      if (e.target.value === "") {
                        setShowMessage(false);
                        setWorkFLowLogList([]);
                        fnLogList(e.target.value);
                      }
                    }}
                  />
                </InputGroup>
              </div>
            ) : (
              <div className="serch-grp-only-search cursor-pointer">
                <img
                  src={searchicon}
                  alt="searchicon"
                  onClick={handleshowSearch}
                />
              </div>
            )}
            <div
              className="filtering-main"
              id="log-filter-two"
              onClick={(e) => {
                e.preventDefault();
                handleOverlay(e);
                setShowSchedularPopup(!showSchedularPopup);
                handleshowSchedularPopup();
              }}
              ref={targetFilter}
            >
              <img src={filtericon} alt="filtericon" />
              <span>Filter</span>
            </div>
            {showSchedularPopup && (
              <Overlay
                target={targetFilter.current}
                show={handleshowSchedularPopup}
                placement="bottom"
              >
                <Tooltip id="overlay-example">
                  <WorkFlowLogFilterPopup
                    setShowMessage={setShowMessage}
                    handleshowPopup={handleshowSchedularPopup}
                    handleSubmit={handleSchedularSubmit}
                    FilterData={FilterData}
                    FnForSetStatus={FnForSetStatus}
                    status={status}
                  />
                </Tooltip>
              </Overlay>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="table-wrapper-main table-wrapper-main-without-border">
            <Table responsive>
              <thead>
                <tr>
                  <th className="width200">Date</th>
                  <th className="width150">Run At</th>
                  <th className="width150">End At</th>
                  <th className="width200">Duration</th>
                  <th className="width150">Status</th>
                  <th className="text-start">Note</th>
                  <th className="text-end sticky-actions">Action</th>
                </tr>
              </thead>
              <tbody>
                {Loading ? (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </td>
                  </tr>
                ) : WorkFLowLogList.length > 0 ? (
                  WorkFLowLogList?.map((item, index) => (
                    <tr>
                      <td>
                        {commonservices.getDateInFormatCustom(
                          item?.starton,
                          null,
                          "MM/DD/yyyy"
                        )}
                      </td>
                      <td>{commonservices.getTimeInFormat(item?.starton)}</td>
                      <td>
                        {item?.status !== "start"
                          ? commonservices.getTimeInFormat(item?.endon)
                          : ""}
                      </td>
                      <td>
                        {item?.status !== "start"
                          ? commonservices.calculateDuration(
                            item?.starton,
                            item?.endon
                          )
                          : ""}
                      </td>
                      <td>{commonservices?.getlogPopupStatus(item?.status)}</td>
                      {/* <td>
                        {
                          // commonservices.getStatusUI(item?.status)
                          commonservices.getStatus(item?.status)
                        }
                      </td> */}
                      <td className="text-start">
                        {item.logdata ? (
                          <ul className="ps-3">
                            {item.logdata
                              .split("\n")
                              .map((text, index) =>
                                text ? <li key={index}>{text}</li> : null
                              )}
                          </ul>
                        ) : null}
                      </td>
                      <td className="text-end sticky-actions">
                        <img
                          className="cursor-pointer"
                          onClick={() => {
                            fnWorkflowMachineLoggetlist(
                              item.workflowschedulelogid
                            );
                          }}
                          src={viewAction}
                          alt="viewAction"
                          title="View"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      <Nodata />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>

      {modalDetailShow && workflowlogid > 0 && (
        <WorkFlowMachineLogDetailModal
          show={modalDetailShow}
          id={workflowlogid}
          onHide={() => setDetailModalShow(false)}
        />
      )}
    </>
  );
}

export default WorkFlowLogModal;
